"use client";

import Link from "next/link";
import { CompanyInfo } from "@/components/legal/CompanyInfo";

const EFFECTIVE_DATE = "2026-05-30";

const SECTIONS: { heading: string; body: string[] }[] = [
  {
    heading: "1. 개인정보의 수집 항목 및 방법",
    body: [
      "트렌드레인(이하 '회사')은 서비스 제공을 위해 다음 개인정보를 수집합니다.",
      "",
      "가. 필수 수집 항목 (소셜 로그인 시)",
      "  - 카카오 로그인: 회원번호, 이메일, 닉네임, 프로필 이미지 URL",
      "  - (향후) 네이버·구글 로그인: 동등 범위",
      "",
      "나. 서비스 이용 중 자동 생성되는 정보",
      "  - 접속 로그, 접속 IP, 쿠키, 이용 기록, 디바이스 정보, 브라우저 종류",
      "  - 저장한 키워드, 커뮤니티 게시물·댓글·좋아요 기록, AI 호출 로그",
      "",
      "다. 유료 결제 시",
      "  - PG사를 통한 결제 정보(카드 정보는 PG사가 직접 보관, 회사는 결제 성공 여부 및 거래 ID만 보관)",
      "",
      "라. 알림 설정 시",
      "  - 이메일 주소, 텔레그램 chat ID (이용자가 직접 입력)",
    ],
  },
  {
    heading: "2. 개인정보의 수집·이용 목적",
    body: [
      "① 회원 식별 및 본인 확인, 회원제 서비스 제공",
      "② 서비스 이용 통계 분석 및 품질 개선",
      "③ 유료 구독 결제·환불 및 관련 고지",
      "④ 알림 서비스 발송 (급상승 키워드, 관심 아이템 변동 등)",
      "⑤ 커뮤니티 모더레이션 및 부정 이용 방지",
      "⑥ 법령상 의무 이행 및 분쟁 해결",
    ],
  },
  {
    heading: "3. 개인정보의 보유·이용 기간",
    body: [
      "① 회원 탈퇴 시 즉시 파기함을 원칙으로 하되, 관련 법령에 따라 아래 기간 동안 보존합니다.",
      "  - 전자상거래법: 계약 또는 청약철회 기록 5년 / 대금결제·재화공급 기록 5년 / 소비자 불만·분쟁처리 기록 3년",
      "  - 통신비밀보호법: 접속 로그 3개월",
      "② 부정 이용 방지 목적으로 이용이 정지된 계정의 일부 정보는 재가입 방지를 위해 최대 1년간 보관합니다.",
    ],
  },
  {
    heading: "4. 개인정보의 제3자 제공",
    body: [
      "회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만 아래의 경우는 예외로 합니다.",
      "  - 이용자가 사전에 동의한 경우",
      "  - 법령의 규정에 의하거나 수사 목적으로 관련 기관의 적법한 절차에 따른 요청이 있는 경우",
    ],
  },
  {
    heading: "5. 개인정보 처리 위탁",
    body: [
      "회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리를 위탁하고 있습니다.",
      "",
      "  - 카카오: 소셜 로그인 인증, 알림톡 발송",
      "  - OpenAI: AI 검색·요약 기능 수행 (사용자 질의 및 트렌드 컨텍스트 전송, 개인 식별 정보는 포함하지 않음)",
      "  - PG사(예: 토스페이먼츠): 결제 처리",
      "  - 클라우드 인프라 제공사: 서버 및 DB 운영",
      "  - 이메일·텔레그램: 알림 발송 대행",
      "",
      "위탁 시 개인정보 보호 관련 법령 준수, 기술적·관리적 보호조치 이행, 재위탁 제한, 위탁업무 종료 시 개인정보 파기 의무 등을 계약서에 명시하여 관리·감독합니다.",
    ],
  },
  {
    heading: "6. 정보주체의 권리와 행사 방법",
    body: [
      "이용자는 언제든지 다음 권리를 행사할 수 있습니다.",
      "  - 개인정보 열람 요구",
      "  - 오류 등이 있을 경우 정정 요구",
      "  - 처리 정지 요구",
      "  - 삭제 요구 (회원 탈퇴로 대체 가능)",
      "",
      "권리 행사는 마이페이지 또는 개인정보 보호책임자 연락처를 통해 가능하며, 회사는 지체 없이 조치합니다.",
    ],
  },
  {
    heading: "7. 개인정보의 파기 절차 및 방법",
    body: [
      "① 보유 기간이 경과했거나 이용 목적이 달성된 개인정보는 지체 없이 파기합니다.",
      "② 전자적 파일: 복구 불가능한 방법으로 영구 삭제",
      "③ 종이 문서: 분쇄 또는 소각",
    ],
  },
  {
    heading: "8. 개인정보의 안전성 확보 조치",
    body: [
      "  - 관리적 조치: 개인정보 취급자 최소화 및 정기 교육",
      "  - 기술적 조치: 접근권한 관리, 암호화 통신(HTTPS/TLS), 비밀번호 해시 처리, 접속 로그 보관 및 주기적 감사",
      "  - 물리적 조치: 서버 접근 통제 구역 운영",
    ],
  },
  {
    heading: "9. 쿠키 및 자동 수집 도구",
    body: [
      "① 회사는 로그인 세션 유지, 이용자 선호도 저장, 서비스 이용 분석을 위해 쿠키를 사용할 수 있습니다.",
      "② 이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으나, 이 경우 로그인 유지 등 일부 기능 사용에 제약이 발생할 수 있습니다.",
    ],
  },
  {
    heading: "10. 개인정보 보호책임자",
    body: [
      "  - 성명: 김현경",
      "  - 직책: 개인정보 보호책임자",
      "  - 이메일: arsenium@naver.com",
      "",
      "이용자는 서비스 이용 중 발생하는 개인정보 관련 문의·불만을 위 연락처로 신고하실 수 있으며, 회사는 지체 없이 답변 및 처리합니다.",
    ],
  },
  {
    heading: "11. YouTube API Services 이용 및 Google 개인정보처리방침",
    body: [
      "① 본 서비스는 트렌드 분석 및 레시피 연계를 위해 YouTube API Services 를 이용합니다.",
      "② 회사는 YouTube API Services 를 통해 공개 콘텐츠 메타데이터(영상 제목·설명·통계 등)만을 수집하며, YouTube 사용자 인증(OAuth) 기반 개인 데이터는 수집하지 않습니다.",
      "③ YouTube API Services 이용과 관련하여 적용되는 Google 의 개인정보 처리 방침은 아래에서 확인하실 수 있습니다.",
      "  - Google 개인정보처리방침: https://policies.google.com/privacy",
      "④ 이용자는 Google 보안 설정 페이지(https://security.google.com/settings/security/permissions)에서 본 서비스를 포함한 외부 앱의 Google 계정 데이터 접근 권한을 언제든지 철회할 수 있습니다.",
    ],
  },
  {
    heading: "12. 개인정보처리방침의 변경",
    body: [
      "본 방침은 법령·정책 또는 서비스 변경에 따라 개정될 수 있으며, 개정 시 시행일 7일 이전부터 서비스 내에 공지합니다. 중대한 변경의 경우 30일 이전에 공지합니다.",
      "",
      "[개정 이력]",
      "  - 2026-05-30: YouTube API Services 이용 및 Google 개인정보처리방침 참조 조항(11) 신설",
    ],
  },
];

export default function PrivacyPage() {
  return (
    <div className="pb-24">
      {/* 헤더 */}
      <div className="sticky top-0 z-40 bg-bg/90 backdrop-blur-md border-b border-border px-4 py-3 flex items-center gap-3">
        <Link href="/mypage" className="text-text-sub hover:text-text transition-colors">
          ←
        </Link>
        <h1 className="text-base font-black text-text">개인정보처리방침</h1>
      </div>

      {/* 시행일 */}
      <div className="px-4 mt-4">
        <p className="text-xs text-text-sub">시행일: {EFFECTIVE_DATE}</p>
      </div>

      {/* 본문 */}
      <div className="px-4 mt-3 space-y-5">
        {SECTIONS.map((sec) => (
          <section key={sec.heading} className="card">
            <h2 className="text-sm font-bold text-text mb-2">{sec.heading}</h2>
            <div className="space-y-2">
              {sec.body.map((line, i) => (
                <p
                  key={i}
                  className={`text-[12px] leading-relaxed whitespace-pre-wrap ${
                    line === "" ? "h-1" : "text-text-sub"
                  }`}
                >
                  {line || " "}
                </p>
              ))}
            </div>
          </section>
        ))}

        <CompanyInfo />

        <p className="text-2xs text-text-sub text-center pt-2">
          본 방침은 관련 법령 및 서비스 변경에 따라 갱신될 수 있으며, 갱신 시 시행일 전 공지됩니다.
        </p>
      </div>
    </div>
  );
}
